<template>
  <div>
    <v-container fluid v-if="!EditdialogUser && !AddVector">
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t("PositiveQuestionSet") }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      id="positivename-field-search-validationpositive"
                      :label="'Positive name'"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      v-model="searchPositiveName"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      prepend-icon="mdi-magnify"
                      @click="Search"
                    >
                      {{ $t('search') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            
            <v-col cols="6" class="d-flex flex-wrap justify-end" style="display: flex; align-items: center;">
              <v-btn
                id="button-add-validationpositive"
                color="primary"
                class="control-btn create-btn mr-10"
                variant="elevated"
                size="large"
                prepend-icon="mdi-plus-circle"
                rounded="xl"
                @click="Add()"
              >
                <span class="btn-text">{{ $t('add') }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="loading"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td>{{ item.name }}</td>
              <td style="text-align: center">{{ item.createBy }}</td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center;">
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-popupedit-validationpositive"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-icon size="18">mdi-pencil-outline</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Edit
                    </v-tooltip>
                  </v-btn>
                  <!-- Custom Divider -->
                  <div class="action-divider"></div>
                  
                  <!-- Delete -->
                  <v-btn
                    id="button-delete-popupedit-validationpositive"
                    variant="text"
                    density="comfortable"
                    @click="DeleteByName(item.id)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-icon size="18">mdi-delete-outline</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
        <br />
        <br />
        <br />
      </v-card>
    </v-container>

    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import LogTrace from "@/api/function.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "ValidationPositive",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    uploadDialog: false,
    checkbox1: false,
    EditdialogUser: false,
    AddVector: false,
    dialog: false,
    loadingTable: false,
    loading: true,
    loadingDownload: true,
    today: null,
    searchPositiveName: null,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    DDModel: [],
    files: [],
    dataTable: [],
    headers: [],
    isSearch: false,
    isFirst: true,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,

    showTable: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    sortBy: [],
    sortDesc: [],
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    Get() {
      let self = this;
      // self.dialog = true;
      self.loading = true;
      
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchPositiveName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableValidationPositive(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
            self.options.page = temp.page;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          // self.dialog = false;
          self.loading = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          // self.dialog = false;
          self.loading = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      const { page, itemsPerPage } = this.options;
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchPositiveName,
        sortDesc: null,
        sortBy: null,
      };
      self.$call.GetTableValidationPositive(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
            self.options.page = temp.page;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loading = false;
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loading = false;
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.GetDefault();
    },
    back(e) {
      if (e) {
        this.EditdialogUser = false;
        this.AddVector = false;
      }
    },
    DeleteByName(name) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionAllQuestion"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteValidationPositive(
                name,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Clear();
                    self.Get();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      let self = this;
      self.$router.push({
        name: "ValidationPositiveDetail",
        query: {
          // id: null,
        },
      });
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: "ValidationPositiveDetail",
        query: {
          id: item.id,
        },
      });
    },
    Clear() {
      let self = this;

      self.EditdialogUser = false;
      self.AddVector = false;
      self.showTable = false;

      self.requestVector.entity = null;
      self.requestVector.modelId = null;
      self.requestVector.modelType = null;
      self.requestVector.vectordbName = null;

      self.searchPositiveName = null;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    download() {
      const data = [];
      data.push("text_org,text_en\n");
      data.push("ชื่อบทความ (วรรณคดี): พระอภัยมณี,\n");
      data.push("Article Title (Literature): Phra Abhayamani,\n");
      data.push("Article Title (Literature): Phra Abhayamani (พระอภัยมณี),");

      const a = document.createElement("a");
      let blob = new Blob(data, { type: "data:text/csv;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = "upload_vector.csv";
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
  },
  mounted() {
    this.GetDate();
    this.headers = [
      { title: this.$t("no"), align: "center", sortable: false },
      {
        title: "Positive Question Set",
        align: "center",
        sortable: true,
        value: "Name",
      },
      {
        title: "Create by",
        align: "center",
        sortable: true,
        value: "CreateBy",
      },
      { title: this.$t("action"), align: "center", sortable: false, width: "150px" },
    ];
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}
.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}
</style>
